<template>
    <div>
        <span v-if="showTotal">
            {{total}}€ 
            <span class="text-xs" v-if="order.shipping_fee > 0">
                +{{order.shipping_fee}}€ consegna
            </span>
        </span>
        <span class="flex items-center" v-else>
            <span>
            <svg viewBox="0 0 20 20" fill="currentColor" class="w-5 h-5 text-red-500 exclamation"><path fill-rule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clip-rule="evenodd"></path></svg>
            </span>
                
            <span class="text-xs">
                prezzo variabile
            </span>
        </span>
    </div>
</template>

<script>
export default {
    name: 'OrderPrice',
    props: {
        order:{
            type: Object,
            required: true
        }
    },
    data() {
        return {
            total:null,
            showTotal:true
        }
    },

    mounted() {
        this.calc();
  },

  methods:{
      calc(){
          for (let i=0; i<this.order.order_detail.length && this.showTotal; i++){
            let dish = this.order.order_detail[i];
            if(dish.unit == '€' || dish.unit == '€/calice'){
                this.total += dish.price * dish.qty
            }else{
                this.showTotal = false;
            }
        }
      }
  },

  watch: { 
      	// eslint-disable-next-line prettier/prettier
          order: function() { // watch it
          this.total=0;
         this.calc();
        }
      }


}
</script>

<style>

</style>